/* unplugin-vue-components disabled */import i18n from '@/lang';
/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import XDialog from "vux/src/components/x-dialog/index.vue"; // this line is trasformed by vux-loader
export default {
  name: 'TpDialog',
  components: {
    XDialog: XDialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    headerUrl: String,
    title: {
      type: String
    },
    cancelDefaulEvent: {
      type: Boolean,
      default: true
    },
    footerHide: {
      type: Boolean,
      default: false
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    cancelText: {
      type: String,
      default: i18n.tc("11")
    },
    successText: {
      type: String,
      default: i18n.tc("12")
    }
  },
  data: function data() {
    return {
      showToast: this.value,
      // XDialog弹窗显示
      hasFooterSlot: false,
      hasHeaderSlot: false
    };
  },
  watch: {
    value: function value(val) {
      this.showToast = val;
    },
    showToast: function showToast(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    onCancel: function onCancel() {
      if (this.cancelDefaulEvent) this.showToast = false;
      this.$emit('on-cancel');
    }
  },
  mounted: function mounted() {
    this.$slots.footer && (this.hasFooterSlot = true);
    this.$slots.header && (this.hasHeaderSlot = true);
  }
};